import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProfilModel } from '../models/profil.model';
import { TokenService } from './token-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfilService {
  private baseUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  private getHeaders(): { headers: HttpHeaders } {
    const org = sessionStorage.getItem('currentOrganization');
    const orgId = org ? JSON.parse(org).id : '';
    const token = this.tokenService.getToken();

    const headers = new HttpHeaders({
      'X-OrganizationId': orgId,
      Authorization: `Bearer ${token}`,
    });

    return { headers };
  }

  /**
   * Récupère tous les profils disponibles pour l'utilisateur connecté.
   */
  getProfils(): Observable<ProfilModel[]> {
    return this.http.get<ProfilModel[]>(
      `${this.baseUrl}/profils`,
      this.getHeaders()
    );
  }

  /**
   * Récupère un template de profil par son ID.
   * @param id ID du profil
   */
  getProfil(id: number): Observable<ProfilModel> {
    return this.http.get<ProfilModel>(
      `${this.baseUrl}/profil/${id}`,
      this.getHeaders()
    );
  }

  /**
   * Applique un profil à un utilisateur cible (GUM).
   * @param userId ID de l'utilisateur cible
   * @param profilId ID du profil à appliquer
   */
  applyProfil(userId: string, profilId: number): Observable<string> {
    return this.http.post<string>(
      `${this.baseUrl}/profil/apply`,
      { userId, profilId },
      {
        ...this.getHeaders(),
        responseType: 'text' as 'json', // important pour que TypeScript compile
      }
    );
  }
}
